<template>
  <div class="pl-side-nav">
    <div
      v-for="item in routes"
      :key="item.uri"
      class="pl-nav-item"
      :class="{ 'is-active': isActiveMenu(item) }"
      @click="navigateTo(item.uri)"
    >
      <i :class="getIcon(item)"></i>
      <span class="pl-nav-label">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectSideMenu',

  computed: {
    routes () {
      const surveyRoutes = (this.$store.state.surveyRoutes || []).filter(item => item.is_menu === '1')
      
      if (surveyRoutes.length > 0) {
        return surveyRoutes
      }
      
      return [
        { id: 1, name: '项目', uri: '/project', icon: 'el-icon-folder', is_menu: '1' },
        { id: 2, name: '回收站', uri: '/recycle', icon: 'el-icon-delete', is_menu: '1' },
        { id: 3, name: '设置', uri: '/settings', icon: 'el-icon-setting', is_menu: '1' }
      ]
    },
    
    currentActiveRoute() {
      const path = this.$route.path
      const metaActive = this.$route.meta?.active
      
      if (path === '/' || path === '') {
        return this.routes.find(r => r.uri === '/' || r.uri === '') || this.routes[0]
      }
      
      if (metaActive) {
        const allPermissions = this.$store.state.allPermissions || []
        let matchedRoute = this.routes.find(r => r.uri === metaActive)
        if (matchedRoute) return matchedRoute
        
        const item = allPermissions.find(p => p.uri === metaActive)
        if (item && item.parent_id) {
          const parent = allPermissions.find(p => p.id === item.parent_id)
          if (parent) {
            matchedRoute = this.routes.find(r => r.uri === parent.uri)
            if (matchedRoute) return matchedRoute
          }
        }
      }
      
      if (path.startsWith('/project')) {
        return this.routes.find(r => r.uri === '/' || r.uri === '/project') || this.routes[0]
      }
      
      for (const route of this.routes) {
        if (route.uri && route.uri !== '/' && route.uri !== '') {
          if (path === route.uri || path.startsWith(route.uri + '/')) {
            return route
          }
        }
      }
      
      return this.routes[0] || null
    }
  },
  
  methods: {
    getIcon(item) {
      const iconMap = {
        '项目': 'el-icon-folder',
        '项目列表': 'el-icon-folder',
        '回收站': 'el-icon-delete',
        '设置': 'el-icon-setting',
        '系统设置': 'el-icon-setting'
      }
      return item.icon || iconMap[item.name] || 'el-icon-menu'
    },
    
    isActiveMenu(item) {
      const activeRoute = this.currentActiveRoute
      if (!activeRoute) return false
      return activeRoute.uri === item.uri
    },
    
    navigateTo(uri) {
      const targetUri = (uri === '/' || uri === '') ? '/project' : uri
      if (this.$route.path !== targetUri) {
        this.$router.push(targetUri)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pl-side-nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 16px;
}

.pl-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #475569;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s ease;
  
  &:hover {
    background: #f1f5f9;
    color: #0f172a;
  }
  
  &.is-active {
    background: rgba(20, 118, 255, 0.08);
    color: #1476ff;
    font-weight: 500;
  }
  
  i {
    font-size: 18px;
    flex-shrink: 0;
  }
}

.pl-nav-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
